import { CheckboxFormatter, DataGrid, EntityDialog, EntityGrid, FileUploadEditor, ToolButton, defaultNotifyOptions, getjQuery, htmlEncode, tryFirst, DateTimeEditor, EditorUtils } from "@serenity-is/corelib";

EntityGrid.prototype['getButtons'] = (function (old) {
    return function () {

        var buttons = old.call(this) as ToolButton[];

        var addButton = tryFirst(buttons, x => x.cssClass === "add-button");
        if (addButton)
            addButton.icon = "fa-plus-circle text-lime";

        var refreshButton = tryFirst(buttons, x => x.cssClass === "refresh-button");
        if (refreshButton)
            refreshButton.icon = "fa-refresh text-green";

        var pickerButton = tryFirst(buttons, x => x.cssClass === "column-picker-button");
        if (pickerButton)
            pickerButton.icon = "fa-th-list";

        var excelButton = tryFirst(buttons, x => x.cssClass === "export-xlsx-button");
        if (excelButton)
            excelButton.icon = "fa-file-excel-o";

        return buttons;
    };
})(EntityGrid.prototype['getButtons']);

EntityDialog.prototype['getToolbarButtons'] = (function (old) {
    return function () {

        var buttons = old.call(this) as ToolButton[];

        var saveButton = tryFirst(buttons, x => x.cssClass === "save-and-close-button");
        if (saveButton)
            saveButton.icon = "fa-check-circle text-lime";

        var applyButton = tryFirst(buttons, x => x.cssClass === "apply-changes-button");
        if (applyButton)
            applyButton.icon = "fa-clipboard-check text-lime";

        var deleteButton = tryFirst(buttons, x => x.cssClass === "delete-button");
        if (deleteButton)
            deleteButton.icon = "fa-trash-o text-red";

        var cloneButton = tryFirst(buttons, x => x.cssClass === "clone-button");
        if (cloneButton)
            cloneButton.icon = "fa-copy";

        var editButton = tryFirst(buttons, x => x.cssClass === "edit-button");
        if (editButton)
            editButton.icon = "fa fa-edit text-lime";

        return buttons;
    };
})(EntityDialog.prototype['getToolbarButtons']);

//getjQuery()?.datepicker?.setDefaults?.({
//    buttonImage: 'data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDQgMzIgMjMiIGZpbGw9IiNmZmYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTkgNHYxaC00djIyaDIydi0yMmgtNHYtMWgtMnYxaC0xMHYtMXptLTIgM2gydjFoMnYtMWgxMHYxaDJ2LTFoMnYyaC0xOHptMCA0aDE4djE0aC0xOHptNiAydjJoMnYtMnptNCAwdjJoMnYtMnptNCAwdjJoMnYtMnptLTEyIDR2Mmgydi0yem00IDB2Mmgydi0yem00IDB2Mmgydi0yem00IDB2Mmgydi0yem0tMTIgNHYyaDJ2LTJ6bTQgMHYyaDJ2LTJ6bTQgMHYyaDJ2LTJ6Ii8+PC9zdmc+',
//    buttonImageOnly: true,
//    buttonText: '',
//});

//ColumnPickerDialog.prototype['createLI'] = (function (old) {
//    return function (col: Column) {
//        var allowHide = this.allowHide(col);
//        return $("\n<li data-key=\"" + col.id + "\" class=\"" + (allowHide ? "" : "cant-hide") + "\">\n  <span class=\"drag-handle\">\u2630</span>\n  " + htmlEncode(this.getTitle(col)) + "\n  " + (allowHide ? "<i class=\"js-hide fa fa-eye-slash\" title=\"" + text("Controls.ColumnPickerDialog.HideHint") + "\"></i>" : '') + "\n  <i class=\"js-show fa fa-eye\" title=\"" + text("Controls.ColumnPickerDialog.ShowHint") + "\"></i>\n</li>");
//    };
//})(ColumnPickerDialog.prototype['createLI']);


function mergeGridTitle() {
    if (this.mergeTitle && !this.mergeTitle())
        return;

    if (this.titleDiv && this.toolbar && this.toolbar.element && this.toolbar.element.length && this.titleDiv.parent().matches('.s-DataGrid'))
        this.titleDiv.prependTo(this.toolbar.element);
}

var orgSetTitle = DataGrid.prototype["setTitle"];
DataGrid.prototype["setTitle"] = function (value) {
    orgSetTitle.call(this, value);
    mergeGridTitle.call(this);
};

var orgCreateToolbarExtensions = EntityGrid.prototype["createToolbarExtensions"];
EntityGrid.prototype["createToolbarExtensions"] = function () {
    orgCreateToolbarExtensions.call(this);
    mergeGridTitle.call(this);
}

FileUploadEditor.prototype["getToolButtons"] = (function (old) {
    return function () {
        var buttons = old.call(this) as ToolButton[];

        var uploadButton = tryFirst(buttons, x => x.cssClass === "add-file-button");
        if (uploadButton)
            uploadButton.icon = "fa fa-paperclip text-lime";

        var deleteButton = tryFirst(buttons, x => x.cssClass === "delete-button");
        if (deleteButton)
            deleteButton.icon = "fa fa-trash-alt text-red";

        return buttons;
    }
})(FileUploadEditor.prototype["getToolButtons"]);

var orgGetViewOptions = DataGrid.prototype["getViewOptions"];
DataGrid.prototype["getViewOptions"] = function () {
    var opt = orgGetViewOptions.call(this);
    if (opt.rowsPerPage != 0 && opt.rowsPerPage <= 100)
        opt.rowsPerPage = 20;
    return opt;
}

DataGrid.prototype["getPagerOptions"] = function () {
    return {
        view: this.view,
        rowsPerPage: 20,
        rowsPerPageOptions: [20, 100, 500, 1000, 2500]
    };
};

CheckboxFormatter.prototype.format = function (ctx) {
    return `<input type="checkbox"${!!ctx.value ? " checked" : ""} disabled />`;
};

defaultNotifyOptions.escapeHtml = true;
defaultNotifyOptions.positionClass = 'toast-bottom-right';

let $ = getjQuery();
if ($?.fn?.colorbox?.settings) {
    $.fn.colorbox.settings.maxWidth = "85%";
    $.fn.colorbox.settings.maxHeight = "85%";
    $.fn.colorbox.settings.title = function () {
        return this.title === false ? '' : htmlEncode(this.title);
    }
}

const Chart = window['Chart'];
if (Chart) {
    Chart.defaults.color = "#a9a9a9";
}
